import React from 'react';

function Spinner() {
    return <span className={'spinner-loading'} />;
}

export default Spinner;
